import React, { Component } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import querystring from 'query-string'
import { filterCategory, filterVisibility } from '../../../actions/contents/post'
import {isDescendant} from "../../../utils/DomHelper";
import WindowEventHelper from "../../../lib/WindowEventHelper";
import * as CategoryVisibility from "../../../constants/category/CategoryVisibility";
import {DAUMBLOG, TISTORY} from "../../../constants/Service"


/**
 * 카테고리 이름, Icon
 * @param props
 * @returns {*}
 * @constructor
 */
function CategoryLabel(props){
  const {visibility, name} = props;

  return <span className="txt_lab">
          {CategoryVisibility.isPrivate(visibility) && <span className="ico_blog ico_secret">비공개</span>}
    <span className="inner_lab">{name}</span>
        </span>
}

@connect(state => ({
    selectedCategoryId: state.post.condition.category,
    selectedVisibility: state.post.condition.visibility,
}), dispatch => ({
    handleFilterCategory: (categoryId) => {
        dispatch(filterCategory(categoryId))
    },
    handleFilterVisibility: (visibility) => {
        dispatch(filterVisibility(visibility))
    },
    dispatch
}))
class PostHeadFilterPanel extends Component {

    constructor() {
        super();
        this.state = {
            categoryTree : window.Config.blog.categories,
            activateFilterList : false,
        };

        this.handleWindowClick = this.handleWindowClick.bind(this);
        this.filterCategory = this.filterCategory.bind(this);
        this.filterVisibility = this.filterVisibility.bind(this);
    }

    componentDidMount() {
    	WindowEventHelper.add("click", this.handleWindowClick)
    }

    componentWillUnmount() {
    	WindowEventHelper.remove("click", this.handleWindowClick)
    }

    handleWindowClick(e) {
        const { filter } = this.refs;
        const { closeFilterList } = this.props;
        let target = e.target;
        if(!isDescendant(filter, target)){
            closeFilterList(e);
        }
    }

    filterCategory(categoryItem) {
        this.props.handleFilterCategory(parseInt(categoryItem.id));
        this.props.toggleFilterList();
    }

    filterVisibility(visibility) {
        this.props.handleFilterVisibility(visibility);
        this.props.toggleFilterList();
    }

    render() {

        const { categoryTree } = this.state;
        const { selectedCategoryId, selectedVisibility, toggleFilterList, activateFilterList }= this.props;

        let parsed = querystring.parse(location.search);
        // 활성화 시 opt_open
        return (
            <div ref="filter" className={classnames({opt_blog:true, opt_open:activateFilterList})}>
                <button type="button" className="btn_opt" disabled="" onClick={(e) => toggleFilterList(e)}>
                    보기
                    <span className="ico_blog ico_open"/>
                </button>
                <div className="layer_opt layer_double">
                    <Link to={"?"} className="lab_btn lab_all" onClick={(e) => toggleFilterList(e)}>
                        모든 글 보기
                        <input type="button" className="btn_g" value="모든글보기"/>
                    </Link>
                    <strong className="tit_opt">상태별 보기</strong>
                    <ul className="list_opt">
                        <li className={classnames({on: (selectedVisibility == 'all')})}>
                            <Link
                              className='lab_btn'
                                to={"?" + querystring.stringify(Object.assign({}, parsed, {visibility: 'all'}))}
                                onClick={(e) => this.filterVisibility('all')}>
                                전체
                            </Link>
                        </li>
                        <li className={classnames({on: (selectedVisibility == 'visible')})}>
                            <Link
                              className='lab_btn'
                                to={"?" + querystring.stringify(Object.assign({}, parsed, {visibility: 'visible'}))}
                                onClick={(e) => this.filterVisibility('visible')}>
                                공개
                            </Link>
                        </li>
                        <li className={classnames({on: (selectedVisibility == 'hidden')})}>
                            <Link
                              className='lab_btn'
                                to={"?" + querystring.stringify(Object.assign({}, parsed, {visibility: 'hidden'}))}
                                onClick={(e) => this.filterVisibility('hidden')}>
                                비공개
                            </Link>
                        </li>
                      {window.Config.service === TISTORY &&
                        <li className={classnames({on: (selectedVisibility == 'protect')})}>
                          <Link
                            className='lab_btn'
                            to={"?" + querystring.stringify(Object.assign({}, parsed, {visibility: 'protect'}))}
                            onClick={(e) => this.filterVisibility('protect')}>
                            보호
                          </Link>
                        </li>
                      }

                      {window.Config.service === DAUMBLOG &&
                        <li className={classnames({on: (selectedVisibility == 'connected')})}>
                          <Link
                            className='lab_btn'
                            to={"?" + querystring.stringify(Object.assign({}, parsed, {visibility: 'connected'}))}
                            onClick={(e) => this.filterVisibility('connected')}>
                            친구공개
                          </Link>
                        </li>
                      }
                    </ul>
                    <div className="scroll_opt">
                        <strong className="tit_opt">카테고리별 보기</strong>
                        <ul className="list_opt">
                            { categoryTree.map(categoryItem => {

                                if(parseInt(categoryItem.id) == -3)
                                    return <li key={categoryItem.id}
                                        className={classnames({on: (parseInt(categoryItem.id) == parseInt(selectedCategoryId))})}>
                                        <Link
                                          className='lab_btn'
                                            to={"?"} onClick={(e) => this.filterCategory(categoryItem)}>
                                            <CategoryLabel visibility={categoryItem.visibility} name={categoryItem.name}/>
                                        </Link>
                                        { this.renderSubCategory(categoryItem) }
                                    </li>;

                                return <li key={categoryItem.id}
                                    className={classnames({on: (parseInt(categoryItem.id) == parseInt(selectedCategoryId))})}>
                                    <Link
                                      className='lab_btn'
                                        to={"?" + querystring.stringify(Object.assign({}, parsed, {category: categoryItem.id}))}
                                        onClick={(e) => this.filterCategory(categoryItem)}>

                                        <CategoryLabel visibility={categoryItem.visibility} name={categoryItem.name}/>
                                    </Link>
                                    { this.renderSubCategory(categoryItem) }
                                </li>
                                }
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }

    renderSubCategory(categoryItem) {
        if(categoryItem.children){
            let parsed = querystring.parse(location.search);
            return <ul>
                { categoryItem.children.map(subCategoryItem =>
                <li key={subCategoryItem.id} className={classnames({sub_on: (parseInt(subCategoryItem.id) == parseInt(this.props.selectedCategoryId))})}>
                    <Link className='lab_btn' to={"?" + querystring.stringify(Object.assign({}, parsed, { category: subCategoryItem.id }))} onClick={(e) => this.filterCategory(subCategoryItem)}>
                        <span className="ico_blog"/>
                        <CategoryLabel visibility={subCategoryItem.visibility} name={subCategoryItem.name}/>
                    </Link>
                </li>
                )}
            </ul>
        }
    }
}

export default PostHeadFilterPanel;
